import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { Mimetype } from 'app/shared/mimetype';
import { Toast } from 'app/shared/toast/toast';

@Component({
  selector: 'app-drive-search',
  templateUrl: './drive-search.component.html',
  styleUrls: ['./../search-box/search-box.component.css']
})
export class DriveSearchComponent implements OnInit {
  @ViewChild('q', { static: true }) query: ElementRef;
  private timer: any;
  private pos = 50;
  private size = 8;
  searchFocused: boolean;
  searchResult: any[];
  preventBlur: boolean;
  hasMore = false;
  items: any[] = [];
  filterSearch: boolean;
  lessItem: boolean;
  isClear = false;
  @Input() searchSelected = false;
  @Input() typeName: any;
  @Output() selectPath = new EventEmitter<boolean>();
  @Output() isSearch = new EventEmitter<boolean>();
  @Output() searchInput = new EventEmitter<string>();
  @Input() access_token: string;
  pageToken: string;

  @Input() selectFileType: 'google drive' | 'onedrive' | 'dropbox';

  constructor(private router: Router, private route: ActivatedRoute, private service: IdexService, public toast: Toast) {
  }

  ngOnInit(): void {
    if (this.searchSelected) {
      this.filterSearch = true;
    }
    this.route.queryParams.subscribe(params => {
      let q;
      if (params['q']) {
        q = decodeURIComponent(params['q']);
      }
      this.query.nativeElement.value = q || '';
    });
  }

  onSearchChange(input: any) {
    this.items = null;
    this.searchResult = null;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    const q = input.value.trim();
    if (q.length === 0) {
      return;
    }
    if (this.searchSelected) {
      this.searchInput.emit(q);
      this.pos = 50;
      this.size = 50;
    }

    if (!this.searchSelected || (this.searchSelected && q.length > 2)) {
      this.timer = setTimeout(() => {
        this.timer = null;

        switch (this.selectFileType) {
          case 'google drive': {
            this.hasMore = false;
            this.pageToken = '';
            this.service.getGoogleDriveSearch(encodeURIComponent(q), this.access_token, this.size, this.pageToken)
              .subscribe(
                res => {
                  if (this.timer == null) {
                    const data = JSON.parse(res);
                    this.items = data.files;
                    this.hasMore = data.nextPageToken ? true : false;
                    this.pageToken = data.nextPageToken;
                    this.searchResult = data.files;
                    if (this.items.length < 8 && this.hasMore && this.searchSelected) {
                      this.lessItem = true;
                      this.loadMore('', input);
                    }
                  }
                });
            break;
          }
          case 'onedrive': {
            this.service.oneDriveSearchQuery(this.access_token, q, 0, this.size)
              .subscribe(
                res => {
                  if (this.timer == null) {

                    const hitsContainers = res.value[0].hitsContainers[0];

                    if (hitsContainers.hits && hitsContainers.total > 0) {
                      this.items = hitsContainers.hits;
                      this.hasMore = hitsContainers.moreResultsAvailable;
                      this.searchResult = hitsContainers.hits;

                      if (this.items.length < 8 && this.hasMore && this.searchSelected) {
                        this.lessItem = true;
                        this.loadMore('', input);
                      }
                    } else {
                      this.items = [];
                    }
                  }
                }, err => {
                  this.toast.error(err.message)
                });
            break;
          }
           case 'dropbox': {
              this.service.getSearchDropbox(this.access_token, q , this.size)
                 .subscribe(res => {
                    if (this.timer == null) {
                       this.hasMore = res.hasMore;
                       this.items = res.entries.filter((file) => file.folder !== true).sort(this.sortName);
                       this.searchResult = res.entries.filter((file) => file.folder !== true).sort(this.sortName);
                       if (this.items.length < 8 && this.hasMore && this.searchSelected) {
                          this.lessItem = true;
                          this.loadMore('', input);
                       }
                    }
                 }, err => {
                    this.toast.error(err.message)
                 });
              break;
           }
        }


      }, 300);
    } else if (this.searchSelected && q.length < 3) {
      this.items = [];
    }
  }

  onSearchFocus() {
    this.searchFocused = true;
  }

  onSearchBlur() {
    setTimeout(() => {
      if (!this.preventBlur) {
        this.searchFocused = false;
      }
    }, 300);
  }

  clearCheck(input: any) {
    if (input.value.length === 0 && this.searchSelected) {
      this.isSearch.emit(false);
      this.isClear = false;
    }
  }

  search(input: any) {
    input.blur();
    if (!this.searchSelected) {
      this.router.navigate(['/search'], { queryParams: { q: input.value } });
    }
    if (this.searchSelected && input.value.length > 2) {
      this.isSearch.emit(true);
      this.isClear = true;
    }
  }

  clearSearch(input: any) {
    const q = input.value.trim();
    if (this.searchSelected && q.length !== 0 && this.isClear === true && this.searchFocused === false) {
      this.isSearch.emit(false);
      this.query.nativeElement.value = '';
      this.isClear = false;
    }
  }

  selectSearchItem(item: any) {
    this.preventBlur = true;

    switch (this.selectFileType) {
      case 'google drive': {
         if (item.mimeType === 'application/vnd.google-apps.folder') {
            if (!this.searchSelected) {
               this.router.navigate(['/file', item.id]);
            } else if (((item.mimeType !== 'application/vnd.google-apps.folder') && this.getValidateExtension(item.mimeType)) && this.searchSelected) {
               this.query.nativeElement.value = item.name;
               this.selectPath.emit(item);
            }
         } else {
            if (this.getValidateExtension(item.mimeType) && this.searchSelected) {
               this.query.nativeElement.value = item.name;
               this.selectPath.emit(item);
            }
         }
         break;
      }
      case 'onedrive': {
         if ((item.file && this.getValidateExtension(item.file.mimeType)) && this.searchSelected) {
            this.query.nativeElement.value = item.name;
            this.selectPath.emit(item);
         }
         break;
      }
       case 'dropbox':{
         if (((item.mimeType !== 'application/octet-stream' || item.name.endsWith('.zdox')) && this.getValidateExtension(item.mimeType)) && this.searchSelected) {
            this.query.nativeElement.value = item.name;
            this.selectPath.emit(item);
         }
         break;
       }
    }

    this.preventBlur = false;
    this.searchFocused = false;
  }

  loadMore(e, item: any) {
    if ((e.target.scrollHeight <= e.target.scrollTop + e.target.offsetHeight || this.lessItem) && this.hasMore) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      const q = item.value.trim();
      if (q.length === 0) {
        return;
      }
      this.timer = setTimeout(() => {
        this.timer = null;

        switch (this.selectFileType) {
          case 'google drive': {
            this.service.getGoogleDriveSearch(encodeURIComponent(q), this.access_token, this.pos, this.pageToken)
              .subscribe(
                res => {
                  if (this.timer == null) {
                    const data = JSON.parse(res);
                    this.hasMore = data.nextPageToken ? true : false;
                    this.pageToken = data.nextPageToken;
                    this.items.push.apply(this.items, data.files);
                    this.pos += this.size;
                  }
                });
            break;
          }
          case 'onedrive': {
            this.service.oneDriveSearchQuery(this.access_token, q, this.size, this.pos)
              .subscribe(
                res => {
                  if (this.timer == null) {
                    const hitsContainers = res.value[0].hitsContainers[0];
                    if (hitsContainers.hits && hitsContainers.total > 0) {
                      this.hasMore = hitsContainers.moreResultsAvailable;
                      this.items.push.apply(this.items, hitsContainers.hits);
                      this.pos += this.size;
                    }
                  }
                });
            break;
          }
           case 'dropbox': {
              this.service.getSearchDropbox(this.access_token, q , this.pos )
                 .subscribe(res => {
                    if (this.timer == null) {
                       this.hasMore = res.hasMore;
                       this.items = res.entries.filter((file) => file.folder !== true).sort(this.sortName);
                       this.lessItem = false;
                    }
                 }, err => {
                    this.toast.error(err.message)
                 });
              break;
           }
        }

        if (this.items.length < 8 && this.hasMore && this.searchSelected) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
          this.lessItem = true;
          this.loadMore('', item);
        } else {
          this.lessItem = false;
        }


      }, 300);
    }
  }

   sortName(a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
         return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
         return 1;
      }
      return 0;
   }

  getIcon(item: any): string {
     switch (this.selectFileType) {
      case 'google drive': {
        return Mimetype.getIcon(item);
      }
      case 'onedrive': {
        return Mimetype.getIconOneDrive(item);
      }
      case 'dropbox':{
         return Mimetype.getIcon(item);
      }
    }
  }

  getValidateExtension(item: any): boolean {
    return Mimetype.validateExtension(item, this.typeName);
  }
}
